import AbstractRepository from "@/repositories/AbstractRepository";

export default class InsertionRepository extends AbstractRepository {
    protected static resource: string = "ptf-invoice-insertion";

    protected static defaultFields: string[] = [
        "uuid",
        "status",
        "label",
        "grossPrice",
        "discountRate",
        "type",
        "advertisingSpace.campaign",
        "advertisingSpace.media",
        "advertisingSpace.supplier",
        "advertisingSpace.support",
        "advertisingSpace.edition",
        "advertisingSpace.format",
        "advertisingSpace.location",
        "advertisingSpace.broadcastStartDate",
        "advertisingSpace.broadcastEndDate",
        "quotation.quotationNumber",
        "quotation.quotationDate",
        "marketNumber",
        "purchaseOrder.purchaseOrderNumber",
        "purchaseOrder.purchaseOrderIssueDate",
        "pigeDate",
        "invoiceSupport",
        "invoiceClient",
        "invoiceFees",
        "quotationAdSpacePrice",
        "quotationAdSpaceVatPercentage",
        "quotationAdSpaceServiceFeePrice",
        "quotationAdSpaceServiceFeeVatPercentage",
        "quotationTechnicalFeesPrice",
        "quotationTechnicalFeesVatPercentage",
        "quotationTechnicalFeesServiceFeePrice",
        "quotationTechnicalFeesServiceFeeVatPercentage",
        "billingAdSpacePrice",
        "billingAdSpaceServiceFeePrice",
        "billingTechnicalFeesPrice",
        "billingTechnicalFeesServiceFeePrice",
        "billingAdSpaceIncludingTaxesPrice",
        "billingAdSpaceServiceFeeIncludingTaxesPrice",
        "billingTechnicalFeesIncludingTaxesPrice",
        "billingTechnicalFeesServiceFeeIncludingTaxesPrice",
        "totalServiceFeeCompute",
        "totalOperationCompute",
        "totalOperationIncludingTaxesCompute",
        "request.createdBy.displayName",
    ];
}
